import React from 'react'
import PropTypes from 'prop-types'
import {i18n} from '../../../Utils'
import Label from '../Atoms/Label'
import Hint from '../Atoms/Hint'
import Checkbox from '../Atoms/Checkbox'
import styled from 'styled-components'
import {lighten} from 'polished/lib/index'
import {desaturate} from 'polished'

const AllowZerosCheckbox = ({onChange, checked, labelColor}) => {
    return (
        <Wrapper>
            <CheckboxLabel
                htmlFor={'allow-zeros-checkbox'}
                color={checked ? labelColor : desaturate(0.5, lighten(0.3, labelColor))}>
                <Checkbox
                    id={'allow-zeros-checkbox'}
                    onChange={onChange}
                    uncheckedColor={desaturate(0.5, lighten(0.3, labelColor))}
                    checkedColor={labelColor}
                    checked={checked}/>
                {i18n('form.checkbox.label.allow_zeros')}
                <Hint color={checked ? labelColor : desaturate(0.5, lighten(0.3, labelColor))}>
                    {i18n('form.checkbox.hint.allow_zeros')}
                </Hint>
            </CheckboxLabel>
        </Wrapper>
    )
}

AllowZerosCheckbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func,
    labelColor: PropTypes.string,
}

export default AllowZerosCheckbox

const CheckboxLabel = styled(Label)`
    cursor: pointer;
    display: flex;
    align-items: center;
`

const Wrapper = styled.div`
    padding: 10px 0;
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Molecules/AllowZerosCheckbox.jsx